/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <ModalExito v-show="mostrarExito" :mostrarExito="mostrarExito" />
  <ModalConfirmacion v-if="mostrarModalConfirmacion" @confirmar="eliminarFerreteria" @cancelar="cancelarEliminacion"
    :nombreUsuario="nombreFerreteria" />
  <LoadScreen v-if="mostrarLoaderDos" />
  <LayoutPrincipal>
    <ContainerWhite>
      <div style="height: 100%;">
        <section class="filtrosEmpleados">
          <div class="tituloModulo">Módulo Ferreterías</div>
          <div>
            <input class="inputBuscador" type="text" v-model="searchText"
              placeholder="Buscar ferretería por nombre o número" />
            <Button class="btn-agregar" @click="mostrarAddFerreteria">Agregar</Button>
          </div>
        </section>

        <section class="tabla-con-loader">
          <div class="tabla-scrollable">
            <table class="default">
              <thead>
                <tr class="cabecera">
                  <th>No. ID</th>
                  <th>Nombre</th>
                  <th>Ciudad</th>
                  <th>Estado</th>
                  <th>Domicilio</th>
                  <th>Correo</th>
                  <th>Teléfono</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-if="mostrarLoaderInterno" class="fila-loader">
                  <td colspan="9" class="loader-wrapper">
                    <LoadScreenModal class="loader-solo" />
                  </td>
                </tr>
                <tr v-else-if="filteredList.length === 0">
                  <td colspan="9" class="mensajeNoResultados">
                    No se encontraron resultados
                  </td>
                </tr>

                <tr v-else v-for="ferreteria in filteredList" :key="ferreteria.id">
                  <td>{{ ferreteria.id.toString().padStart(3, '0') }}</td>
                  <td>{{ ferreteria.nombre }}</td>
                  <td>{{ ferreteria.ciudad }}</td>
                  <td>{{ ferreteria.estado }}</td>
                  <td>{{ ferreteria.domicilio }}</td>
                  <td>{{ ferreteria.correo }}</td>
                  <td>{{ ferreteria.telefono }}</td>
                  <td>
                    <div class="botonesTabla">
                      <Button class="btn-editar" @click="mostrarTabla(ferreteria.id)" title="Editar precios">
                        <i class="fa-solid fa-sliders"></i>
                      </Button>
                      <Button class="btn-editar" @click="mostrarEditar(ferreteria.id)" title="Editar ferretería">
                        <i class="fa-solid fa-pen-to-square"></i>
                      </Button>
                      <Button class="btn-eliminar" @click="confirmarEliminacion(ferreteria)"
                        title="Eliminar ferretería">
                        <i class="fa-solid fa-trash"></i>
                      </Button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </ContainerWhite>

    <AgregarFerreteria v-if="mostrarModalAgregar" @cancelar="mostrarModalAgregar = false"
      @guardado="agregarFerreteria" />

    <EditarFerreteria v-if="mostrarModalEditar" :ferreteria="ferreteriaSeleccionada"
      @cancelar="mostrarModalEditar = false" />

    <TablaFerreteria v-if="mostrarModalTablaDetalles" :ferreteria="ferreteriaSeleccionadaTabla"
      @cancelar="mostrarModalTablaDetalles = false" />
    <Paginacion class="paginacion-fija" />
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import ContainerWhite from "../layouts/ContainerWhite.vue";
import Button from "../components/Forms/Button.vue";
import Paginacion from "../components/Forms/Paginacion.vue";
import AgregarFerreteria from "../components/Ferreteria/AgregarFerreteria.vue";
import EditarFerreteria from "../components/Ferreteria/EditarFerreteria.vue";
import ModalExito from "../components/Modales/ModalExito.vue";
import ModalConfirmacion from "../components/Modales/ModalConfirmacion.vue";
import LoadScreen from "../components/Forms/LoadScreen.vue";
import LoadScreenModal from "../components/Forms/LoadScreenModal.vue";
import TablaFerreteria from "../components/Ferreteria/TablaFerreteria.vue";


export default {
  components: {
    LayoutPrincipal,
    ContainerWhite,
    Button,
    Paginacion,
    AgregarFerreteria,
    EditarFerreteria,
    ModalExito,
    ModalConfirmacion,
    LoadScreen,
    LoadScreenModal,
    TablaFerreteria,
  },
  data() {
    return {
      searchText: "",
      ferreterias: [],
      mostrarModalAgregar: false,
      mostrarModalEditar: false,
      mostrarModalConfirmacion: false,
      mostrarLoaderDos: false, 
      mostrarLoaderInterno: false, 
      mostrarExito: false,
      ferreteriaSeleccionada: null,
      nombreFerreteria: "",
      mostrarModalTablaDetalles: false,
      ferreteriaSeleccionadaTabla: null,
    };
  },
  computed: {
    filteredList() {
      const term = this.searchText.toLowerCase();
      return this.ferreterias.filter(
        (f) =>
          f.nombre.toLowerCase().includes(term) ||
          f.id.toString().includes(term)
      );
    },
  },
  methods: {
    async obtenerFerreterias() {
      this.mostrarLoaderInterno = true;
      setTimeout(() => {
        this.ferreterias = [
          {
            id: 1,
            nombre: "Ferretería El Tornillo Feliz",
            ciudad: "Culiacán",
            estado: "Sinaloa",
            domicilio: "Av. Álvaro Obregón 2345, Col. Centro",
            correo: "contacto@eltornillofeliz.com",
            telefono: "667-123-4567",
          },
          {
            id: 2,
            nombre: "Ferretería La Nueva Era",
            ciudad: "Mazatlán",
            estado: "Sinaloa",
            domicilio: "Av. del Mar 1020, Zona Dorada",
            correo: "ventas@lanuevaera.mx",
            telefono: "669-555-8899",
          },
          {
            id: 3,
            nombre: "Ferretería Los Mochis",
            ciudad: "Los Mochis",
            estado: "Sinaloa",
            domicilio: "Blvd. Rosales 501, Centro",
            correo: "info@losmochisferre.mx",
            telefono: "668-555-4411",
          },
        ];
        this.mostrarLoaderInterno = false;
      }, 900);
    },

    mostrarAddFerreteria() {
      this.mostrarModalAgregar = true;
    },

    mostrarEditar(id) {
      const ferreteria = this.ferreterias.find((f) => f.id === id);
      if (ferreteria) {
        this.ferreteriaSeleccionada = { ...ferreteria };
        this.mostrarModalEditar = true;
      }
    },

    mostrarTabla(id) {
      const ferreteria = this.ferreterias.find((f) => f.id === id);
      if (ferreteria) {
        this.ferreteriaSeleccionadaTabla = { ...ferreteria };
        this.mostrarModalTablaDetalles = true;
      }
    },

    confirmarEliminacion(ferreteria) {
      this.ferreteriaSeleccionada = ferreteria;
      this.nombreFerreteria = ferreteria.nombre;
      this.mostrarModalConfirmacion = true;
    },

    eliminarFerreteria() {
      this.mostrarModalConfirmacion = false;
      this.mostrarLoaderDos = true;
      setTimeout(() => {
        this.ferreterias = this.ferreterias.filter(
          (f) => f.id !== this.ferreteriaSeleccionada.id
        );
        this.mostrarLoaderDos = false;
        this.mostrarExito = true;
        setTimeout(() => (this.mostrarExito = false), 1500);
      }, 1000);
    },

    cancelarEliminacion() {
      this.mostrarModalConfirmacion = false;
      this.ferreteriaSeleccionada = null;
    },

    agregarFerreteria(nuevaFerreteria) {
      const id = this.ferreterias.length + 1;
      this.ferreterias.push({ id, ...nuevaFerreteria });
    },
  },
  mounted() {
    this.obtenerFerreterias();
  },
};
</script>

<style scoped>
.filtrosEmpleados {
  justify-content: space-between;
  display: flex;
  padding: 20px 20px 20px 50px;
  align-items: center;
}

.tituloModulo {
  font-size: 25px;
  color: #2a428c;
  font-weight: bolder;
  font-style: italic;
}

.inputBuscador {
  width: 300px;
  height: 32px;
  border: 0px solid #000000;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  padding: 0px 10px;
  border-radius: 10px;
  margin-right: 20px;
  position: relative;
  z-index: 10;
}

.tablaPrincipal {
  width: 100%;
  overflow-x: auto;
  overflow-x: hidden;
}

.default {
  border-collapse: collapse;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
}

.cabecera {
  background: black;
  color: white;
}

.default td,
.default th {
  border: none;
  padding: 15px 12px;
  text-align: center;
}

.default tr:nth-child(even) {
  background-color: #f8f8f8;
}

.default th {
  background-color: black;
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
}

.tbody {
  font-size: 14.5px;
}

.mensajeNoResultados {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #691c32;
  padding: 20px 0;
}

.contenedor-principal {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 120px);
}

.contenido-flex {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.paginacion-fija {
  margin-top: auto;
}

.tabla-con-loader {
  position: relative;
}

.fila-loader {
  position: relative;
  height: 58vh;
}

.tabla-scrollable {
  max-height: 72vh;
  overflow-y: auto;
  background: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #000;
  color: white;
  z-index: 10;
}

.tabla-scrollable table thead {
  position: sticky;
  top: 0;
  background-color: black;
  z-index: 1;
}

@media (max-width: 810px) {
  .default {
    border-collapse: collapse;
    border-radius: 10px;
    width: 100%;
    box-shadow: 0px 3px 6px #00000029;
    table-layout: auto;
    max-width: 100%;
  }

  .default td {
    padding: 10px 5px;
  }

  .default th {
    font-size: 13px;
    letter-spacing: 0px;
  }

  .tbody {
    font-size: 11px;
  }

  .tituloModulo {
    font-size: 20px;
  }

  .filtrosEmpleados {
    padding: 20px 20px 20px 20px;
  }

  .inputBuscador {
    width: 150px;
    margin-right: 10px;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.4);
    z-index: 10;
    border: 0.5px solid #000000;
    border-radius: 18px;
  }

  .btn-agregar-cobaes {
    width: 23px;
    height: 23px;
    font-size: 10px;
    color: black;
    justify-content: center;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .btn-editar {
    width: 23px;
    height: 23px;
    font-size: 10px;
    color: black;
    justify-content: center;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .btn-eliminar {
    width: 23px;
    height: 23px;
    font-size: 10px;
    justify-content: center;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .botonesTabla {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }

  .inputMovil {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
